const getEstimatedDate = (edd)=>{
    const date = new Date();
    date.setDate(date.getDate()  + edd + 2);
    const estimatedDateDelivery = new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }).format(new Date(date));
    return estimatedDateDelivery;
}
const checkAvailibility = ()=>{
    // Get Token Valid to 24 hours;
    fetch("https://appapi.shipdelight.com/generate-token?api_key=65eaba0ac23f74c2d7346965",{method:"POST"}).then((res) => res.json()).then((result)=>{
      const { success,data } = result;
      if(success){
        const headers = {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${data.access_token}`
        }
        let pincode = document.getElementById("mst_pincode").value;
        console.log(pincode, typeof pincode)
        const params = {
          "pickup_pincode": 400009,
          "delivery_pincode": parseInt(pincode),
          "pay_type": "PPD",
          "service_type": "F",
          "courier_service_type": "AIR"
        } 
        let msgEle = document.getElementById("courial_result");
        fetch("https://appapi.shipdelight.com/serviceability_tat",{method:"POST",headers:headers, body:JSON.stringify(params) }).then((res)=> res.json()).then((result)=>{
          const { data, errors } = result;
          if(errors?.length){
            msgEle.style.color = "red"
            msgEle.innerHTML = 'Invalid Pincode';
          }else{
            const isServicebale = data?.response.delivery_pincode_serviceable;
            var estimateDate = getEstimatedDate(data?.response.edd);
            const msg = data?.response.delivery_pincode_serviceable ? estimateDate : 'Service is not available at this location';
            msgEle.style.color = "green"
            msgEle.innerHTML = `Yes, we are available`;
            /* msgEle.innerHTML = `Estimated Delivery Date : ${msg}`;*/
          }
          setTimeout(()=>{
            msgEle.innerHTML = "";
          },5000)
        })
      }
    })
  }
